import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Preloader = ({ onDone }) => {
  const [progress, setProgress] = useState(0);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    let raf;
    let value = 0;
    const start = performance.now();
    const tick = (now) => {
      const docReady = document.readyState === "complete" || now - start > 3000;
      const target = docReady ? 100 : Math.min(90, ((now - start) / 1800) * 100);
      value += (target - value) * 0.1;
      if (value > 99.4) value = 100;
      setProgress(Math.floor(value));
      if (value >= 100) {
        setExiting(true);
        setTimeout(onDone, 900);
      } else {
        raf = requestAnimationFrame(tick);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!exiting ? (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex flex-col justify-between bg-[#0D0D0D] px-6 py-8 md:px-12"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex items-center justify-between">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#4A5568]">
              Prithwish Sahoo
            </span>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#4A5568]">
              Portfolio / 2026
            </span>
          </div>
          <div className="flex items-end justify-between">
            <div className="overflow-hidden">
              <motion.p
                initial={{ y: 40, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.6 }}
                className="max-w-xs font-mono text-xs uppercase tracking-[0.25em] text-[#F4EFEA]/60"
              >
                Loading interactive experience
              </motion.p>
            </div>
            <span
              data-testid="preloader-percentage"
              className="font-display text-7xl font-extrabold leading-none text-[#FDFBF7] md:text-9xl"
            >
              {progress}
              <span className="text-[#00F2FE]">%</span>
            </span>
          </div>
          <div className="h-px w-full bg-[#1A202C]">
            <div
              className="h-px bg-[#00F2FE] transition-[width] duration-200 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
        </motion.div>
      ) : (
        <motion.div
          key="exit"
          className="fixed inset-0 z-[100] bg-[#0D0D0D]"
          initial={{ y: 0 }}
          animate={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        />
      )}
    </AnimatePresence>
  );
};
